/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.0.0
 */
import { ComponentType } from 'react';

const withDefaultProps = <P extends object, DP extends Partial<P> = Partial<P>>(
    defaultProps: DP,
    Cmp: ComponentType<P>,
) => {
    // extracting props that need to be required
    type RequiredProps = Omit<P, keyof DP>
    // re-creating props definition by creating and intersection type
    // between all original props mapped to be optional and required to be required
    type Props = Partial<DP> & Required<RequiredProps>
    // set defaultProps
    Cmp.defaultProps = defaultProps;
    // override return type definition by turning type checker off
    // for original props and setting the correct return type
    return (Cmp as ComponentType<any>) as ComponentType<Props>
};

export default withDefaultProps;
